import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LoginStatus from "./inicio/LoginStatus";
import Aviso from "./inicio/Aviso";
import Orden from "./inicio/Orden";
import Promo from "./inicio/Promo";

const Home = () => {
    return (
        <Container>
            <Row>
                <Col md="6" xs="12">
                    <Row>
                        <Col className="mt-3">
                            <LoginStatus />
                        </Col>
                    </Row>

                    <Row className="mt-3">
                        <Col>
                            <Orden />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Promo />
                        </Col>
                    </Row>
                </Col>

                <Col md="6" xs="12" className="my-3">
                    <Aviso />
                </Col>
            </Row>
        </Container>
    );
};

export default Home;
